import { Swiper } from 'swiper';
import { A11y, Navigation } from 'swiper/modules';
const blocks = document.querySelectorAll('.block-related-posts--slider');
if (blocks.length > 0) {
	blocks.forEach((block) => {
		const slider = block.querySelector('.swiper');
		const sliderButtons = block.querySelector(
			'.block-related-posts__slider-buttons'
		);

		if (!slider || !sliderButtons) {
			return;
		}

		const slides = slider.querySelectorAll('.swiper-slide');

		const settings = {
			loop: slides.length > 4 ? true : false,
			grabCursor: true,
			spaceBetween: 32,
			slidesPerView: 1,
			modules: [A11y, Navigation],
			a11y: {
				itemRoleDescriptionMessage: 'slide',
			},
			navigation: {
				prevEl: sliderButtons.querySelector('.swiper-button-prev'),
				nextEl: sliderButtons.querySelector('.swiper-button-next'),
			},
			breakpoints: {
				576: {
					slidesPerView: 2,
					loop: slides.length > 2 ? true : false,
				},
				768: {
					slidesPerView: 3,
					loop: slides.length > 3 ? true : false,
				},
				992: {
					slidesPerView: 4,
					loop: slides.length > 4 ? true : false,
				},
			},
		};

		new Swiper(slider, settings);
	});
}
